import { TrainOutline24Icon } from "@vygruppen/spor-icon-react";
import { TrainIdentifier } from "@vygruppen/vy-train-map";
import { SkeletonTextSingle } from "features/CenterContent/RoleContent/ProductionDeviation/components/SkeletonTextSingle";
import { InfrastructureResponse } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/responseSchema";
import { BatchSubTypeProps } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/TrainInfoFormModal";
import { BatchSubtypeInputs } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/subTypeInputs";
import { toNonExcludedStops } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/subTypeInputs/utils/listofExcludedStations";
import { DirectionEnum } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/formSchema";
import { useTrainInfoContext } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/useTrainInfoContext";
import { TrainEventTypeEnum } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/types/trainEventTypeEnum";
import { FC, useMemo } from "react";
import { HStack, Stack, Text } from "shared/components/Spor";

const DirectionDescriptor: FC<{
  direction: DirectionEnum;
  representativeTrainId: TrainIdentifier;
}> = ({ direction, representativeTrainId }) => {
  const { useTrainRouteBatch } = useTrainInfoContext();
  const { data, status } = useTrainRouteBatch(representativeTrainId);

  const nonExcludedStops = useMemo(
    () => toNonExcludedStops(data?.stops ?? []),
    [data],
  );

  const origin = nonExcludedStops[0]?.name ?? data?.origin;
  const destination = nonExcludedStops.at(-1)?.name ?? data?.destination;

  return (
    <HStack>
      <TrainOutline24Icon
        style={{ transform: direction === "EVEN" ? "scaleX(-1)" : "scaleX(1)" }}
      />
      {status === "pending" ? (
        <HStack alignItems="center">
          <SkeletonTextSingle />
          <Text fontWeight="bold"> - </Text>
          <SkeletonTextSingle />
        </HStack>
      ) : (
        <Text fontWeight="bold">
          {origin && destination && `${origin} \u2013 ${destination}`} (f.eks{" "}
          {representativeTrainId.identifier})
        </Text>
      )}
    </HStack>
  );
};

type BatchFormProps = {
  eventType: TrainEventTypeEnum;
  direction: DirectionEnum;
  representativeTrainId: TrainIdentifier;
  infrastructureEvent?: InfrastructureResponse;
  isProductionDeviation?: boolean;
  mode: "create" | "edit";
};

export const BatchSubTypeInput: FC<BatchFormProps & BatchSubTypeProps> = ({
  eventType,
  direction,
  representativeTrainId,
  infrastructureEvent,
  isProductionDeviation,
  activeSeriesKey,
  groupIndex,
  mode,
}) => (
  <Stack>
    <DirectionDescriptor
      direction={direction}
      representativeTrainId={representativeTrainId}
    />
    <BatchSubtypeInputs
      activeSeriesKey={activeSeriesKey}
      groupIndex={groupIndex}
      infrastructureEvent={infrastructureEvent}
      isProductionDeviation={isProductionDeviation}
      type={eventType}
      trainId={representativeTrainId}
      mode={mode}
    />
  </Stack>
);
